import * as z from "zod/v4";

export const podcastInquiryFormSchema = z.object({
	firstName: z.string().min(1),
	lastName: z.string().min(1),
	email: z.email(),
	phone: z
		.string()
		.regex(/^\(\d{3}\) \d{3}-\d{4}$/, "Please enter a valid 10-digit phone number"),
	podcastName: z.string().min(1),
	podcastUrl: z.url().optional().or(z.literal("")),
	message: z.string().min(1),
	turnstileToken: z.string()
});

export type PodcastInquiryFormSchema = z.infer<typeof podcastInquiryFormSchema>;
